import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaUser, FaBullhorn, FaEnvelope } from 'react-icons/fa';
import { useMessageNotifications } from './MessageNotificationContext';
import styles from './MessageToastHost.module.css';

/**
 * Gelen mesaj kartları. Layout içinde durur, dolayısıyla kullanıcı hangi
 * sayfada olursa olsun görünür - gelen arama modalıyla aynı mantık, ama
 * sayfayı kaplamayan, kendiliğinden kaybolan bir biçimde.
 */
const MessageToastHost = () => {
  const { notifications, dismissNotification } = useMessageNotifications();
  const navigate = useNavigate();

  const openConversation = useCallback((notification) => {
    dismissNotification(notification.id);
    navigate('/profile', {
      state: {
        activeTab: 'mesajlar',
        openChatWith: notification.senderEmail,
        // Aynı kişiden ikinci bir bildirime tıklandığında ProfilePage'in
        // state'i yeniden işleyebilmesi için değişen bir alan gerekiyor.
        requestedAt: Date.now(),
      },
    });
  }, [dismissNotification, navigate]);

  if (notifications.length === 0) return null;

  return (
    <div className={styles.host} role="region" aria-label="Yeni mesaj bildirimleri">
      {notifications.map((notification) => (
        <div key={notification.id} className={styles.toast} role="status">
          <button
            type="button"
            className={styles.body}
            onClick={() => openConversation(notification)}
            title="Sohbeti aç"
          >
            <span className={styles.avatar}>
              {notification.senderImage ? (
                <img src={notification.senderImage} alt="" />
              ) : (
                <FaUser />
              )}
              <span className={styles.badge}>
                {notification.isBroadcast ? <FaBullhorn /> : <FaEnvelope />}
              </span>
            </span>

            <span className={styles.content}>
              <span className={styles.sender}>{notification.senderName}</span>
              <span className={styles.preview}>{notification.preview}</span>
            </span>
          </button>

          <button
            type="button"
            className={styles.close}
            onClick={() => dismissNotification(notification.id)}
            aria-label="Bildirimi kapat"
          >
            <FaTimes />
          </button>

          <span className={styles.progress} />
        </div>
      ))}
    </div>
  );
};

export default MessageToastHost;
